const xyglGetter = {
    getMyStudys(state) {
        _.forEach(state.studys.Items, obj => {
            obj.percentage = 0;
            if (obj.CompleteLessonCount && obj.CompleteLessonCount) {
                obj.percentage = obj.CompleteLessonCount / obj.LessonCount * 100;
            }
        })
        return state.studys;
    },
    getMyStudysDetails(state) {
        return state.studyDetails;
    },
    getMyStudyLessonAlbumDetails(state) {
        return state.studyLessonAlbumDetails;
    },
    getMyStudyLessonDetails(state) {
        return state.studyLessonDetails;
    },
    getPosttestQuestions(state) {
        return state.posttestQuestions;
    },
    getCourseExamQuestions(state) {
        return state.courseExamQuestions;
    },
    getHgksQuestions(state) {
        return state.hgksQuestions;
    },
    getCertLearncert(state) {
        return state.certLearncert;
    },
    getEmployeePersonaLprofile(state) {
        return state.personaLprofile;
    }
}

export default xyglGetter;



// WEBPACK FOOTER //
// ./src/store/jzjy/getters/xyglGetter.js